// Uploads are written at two widths. Only the full-size URL is stored, and the
// narrow one is derived from it by filename convention — kept in step with
// RENDITIONS in images.js.
const VARIANT_SUFFIX = '-w800';
const NARROW_WIDTH = 800;
const FULL_WIDTH = 1600;

// Images uploaded before renditions existed have no narrow sibling, so only
// generated WebP files opt in. Anything else falls back to a plain src.
const HAS_RENDITIONS = /^\/images\/(wines|events|hero)\/[^/]+\.webp$/i;

export function narrowUrl(url) {
  if (!url || !HAS_RENDITIONS.test(url)) return url;
  return url.replace(/(\.webp)$/i, `${VARIANT_SUFFIX}$1`);
}

// A srcset the browser resolves against `sizes`, taking device pixel ratio into
// account — which is why this is left to the browser rather than decided here.
export function srcSetFor(url) {
  if (!url || !HAS_RENDITIONS.test(url)) return undefined;
  return `${narrowUrl(url)} ${NARROW_WIDTH}w, ${url} ${FULL_WIDTH}w`;
}

// For CSS backgrounds, where srcset does not apply and the choice has to be
// made in JS. Backgrounds sit under a dark overlay, so the narrow rendition is
// a deliberate bandwidth win on phones rather than a quality compromise.
export function backgroundUrl(url, viewportWidth) {
  if (!url || !HAS_RENDITIONS.test(url)) return url;
  return viewportWidth <= NARROW_WIDTH ? narrowUrl(url) : url;
}

// A blurred wash derived from the photo, drawn behind it in an event card so a
// portrait photo fills the slot instead of sitting in the middle with bars.
// Only event card images have one; anything else falls back to a plain colour.
export const CARD_ASPECT = 2;

export function backdropUrl(url) {
  if (!url || !HAS_RENDITIONS.test(url)) return null;
  return url.replace(/(\.webp)$/i, '-blur$1');
}

export { NARROW_WIDTH, FULL_WIDTH };
